import { TranslationKey, unsafeTranslationKey } from 'intl/types/translationKey';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import { getAvailableFieldLabelId } from 'shared/domain/visibleField/availableFields';

export function availableFieldLabelKey(
  fieldName: IssueFieldNames
): TranslationKey {
  return unsafeTranslationKey(getAvailableFieldLabelId(fieldName));
}
